const STORAGE_KEY = 'wsky:tutorial:seen';

interface TutorialStep {
  emoji: string;
  title: string;
  desc: string;
  cta: string;
}

const STEPS: TutorialStep[] = [
  {
    emoji: '✉️',
    title: '云端邮局',
    desc: '云海里住着 5 位 AI 居民。\n他们记得你说过的话，会写出独属于你的回信。',
    cta: '下一步'
  },
  {
    emoji: '🛩',
    title: '滑动蓄力 · 松手投出',
    desc: '在屏幕任意处长按拖动来调角度与力度。\n松开手指，纸飞机就会带着你的信飞出去。',
    cta: '下一步'
  },
  {
    emoji: '🪼',
    title: '收集 5 位居民',
    desc: '鲸鱼·水母·老熊·小狐·星星，五种性格，五种回信。\n每次拜访都会被记下，越熟越聊得深。',
    cta: '开始投递'
  }
];

export class Tutorial {
  private root: HTMLDivElement;
  private idx = 0;
  private resolveDone: (() => void) | null = null;

  constructor(host: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'layer tutorial hidden';
    this.root.innerHTML = `
      <div class="tutorial-card">
        <div class="tutorial-emoji"></div>
        <div class="tutorial-title"></div>
        <div class="tutorial-desc"></div>
        <div class="tutorial-dots"></div>
        <button class="tutorial-cta"></button>
        <button class="tutorial-skip">跳过</button>
      </div>
    `;
    host.appendChild(this.root);
    this.root.querySelector('.tutorial-cta')!.addEventListener('click', e => {
      e.stopPropagation();
      this.next();
    });
    this.root.querySelector('.tutorial-skip')!.addEventListener('click', e => {
      e.stopPropagation();
      this.finish();
    });
    this.root.addEventListener('click', ev => {
      if (ev.target === this.root) this.finish();
    });
  }

  shouldShow(): boolean {
    try { return !localStorage.getItem(STORAGE_KEY); } catch { return true; }
  }

  show(): Promise<void> {
    this.idx = 0;
    this.render();
    this.root.classList.remove('hidden');
    requestAnimationFrame(() => this.root.classList.add('show'));
    return new Promise(res => { this.resolveDone = res; });
  }

  private render(): void {
    const s = STEPS[this.idx];
    (this.root.querySelector('.tutorial-emoji') as HTMLDivElement).textContent = s.emoji;
    (this.root.querySelector('.tutorial-title') as HTMLDivElement).textContent = s.title;
    (this.root.querySelector('.tutorial-desc') as HTMLDivElement).textContent = s.desc;
    (this.root.querySelector('.tutorial-cta') as HTMLButtonElement).textContent = s.cta;
    const dots = STEPS.map((_, i) => `<span class="dot${i === this.idx ? ' active' : ''}"></span>`).join('');
    (this.root.querySelector('.tutorial-dots') as HTMLDivElement).innerHTML = dots;
  }

  private next(): void {
    if (this.idx < STEPS.length - 1) {
      this.idx += 1;
      this.render();
      return;
    }
    this.finish();
  }

  private finish(): void {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* private mode */ }
    this.root.classList.remove('show');
    setTimeout(() => {
      this.root.classList.add('hidden');
      this.resolveDone?.();
      this.resolveDone = null;
    }, 240);
  }
}
